import { useMutation } from 'react-query';
import request from 'utils/request';

const baseURL = '/common';

// 로그인 필수(userId, userPw)
export const useDisLoginInfo = (options) => {
  return useMutation([baseURL, 'disLoginInfo'],
    (params) => request.post('/loginProcess', params),
    { ...options }
  )};

// 로그아웃
export const useDisLogoutInfo = (options) => {
  return useMutation([baseURL, 'disLogoutInfo'],
    (params) => request.post('/logout', params),
    { ...options }
  )};

// 메뉴
export const useDisMenuList = (options) => {
  return useMutation([baseURL, 'disMenuList'],
    (params) => request.callCmd(baseURL + '/DIS-MENU-LIST', params),
    { ...options }
  )};

// 공통코드
export const useDisCodeList = (options) => {
  return useMutation([baseURL, 'disCodeList',],
    (params) => request.callCmd(baseURL + '/DIS-CODE-LIST', params),
    { ...options }
  )};

  // 비밀번호 초기화
export const useModResetPassWordInfo = (options) => {
  return useMutation([baseURL, 'modResetPassWordInfo',],
    (params) => request.callCmd(baseURL + '/MOD-RESETPASSWORD-INFO', params),
    { ...options }
  )
};

// 조직도 tree
export const useDisMemberTreeList = (options) => {
  return useMutation([baseURL, 'disMemberTreeList',],
    (params) => request.callCmd(baseURL + '/DIS-MEMBERTREE-LIST', params),
    { ...options }
  )
};
